import { IdName } from 'interfaces/IdName';
import { isNull, isEmpty } from 'lodash';

export const getFilterLabel = (
  label: string,
  selectedItem?: IdName | null,
): string =>
  !isNull(selectedItem) && !isEmpty(selectedItem) ? selectedItem?.name : label;
